import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect, useParams } from "react-router-dom";
import { activeLcd, addLcd, loginLogoutUserAction } from "../../actions";
import "../../assets/css/scss/component/authentication/_loginForm.scss";
import { validateEmail } from "../../common/emailCheck";
import EncryptData from "../../common/encryption";
import {
  getActiveLcdData,
  getHeaderForAxios,
  getOnlyActiveLcdData,
  getToken,
  getUserData,
} from "../../common/getLocalStorageData";
import { validatePhone } from "../../common/phoneCheck";
import { ADVERTISEMENT_PAGE } from "../../constant/FrontEnd";
import { useLocation } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { GoogleOauthContext } from "../../common/context";
import { useGoogleLogin } from "@react-oauth/google";
import { IReduxStateData } from "../../interfaces/redux";
import { LOGIN_PAGE, SIGN_UP_PAGE } from "../../constant/menuAndProfile";
type Iparams = {
  user_uuid: string;
  otp: string;
};
export default function LoginForm({ refresh }) {
  const dispatch = useDispatch();
  const [emailPhone, setEmailPhone] = useState("");
  const [isEmailUsing, toggleEmailUse] = useState(true);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const params: Iparams = useParams();
  const locationDetail: any = useLocation();
  const [identifier, setIdentifier] = useState<{
    userId?: string;
    otp?: string;
  }>({});
  // const [identifierOtp, setIdentifierOtp] = useState("");
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  const [validation, setValidation] = useState({
    emailPhone: false,
    password: false,
    submit: false,
  });
  const [loginMessage, setLoginMessage] = useState({
    message: "",
    type: "",
  });
  const [redirectToPage, setRedirectToPage] = useState(
    getToken() ? true : false
  );
  const [selectedCountryData, setSelectedCountryData] = useState({
    id: "",
    code: "",
    index: "",
  });

  const [user, setUser] = useState<any>({});
  const [profile, setProfile] = useState({});
  const [resendLinkDisplay, setResendLinkDisplay] = useState(false);
  const [resendEmailConfirmation, setResendEmailConfirmation] = useState(false);
  const isGoogleOauthEnable = useContext(GoogleOauthContext);

  useEffect(() => {
    if (params && params?.user_uuid && params?.otp) {
      setIdentifier({
        userId: params["user_uuid"],
        otp: params["otp"],
      });
    }
    // if (params && params?.otp) {
    //   setIdentifierOtp(params["otp"]);
    // }
  }, []);

  useEffect(() => {
    if (locationDetail?.state?.message) {
      setLoginMessage({
        message: locationDetail?.state?.message,
        type: "success",
      });
    }
  }, [locationDetail]);

  const addLcdData = useCallback(
    (lcdData) => {
      dispatch(addLcd(lcdData));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const activeLcdDetail = useCallback(
    (lcdData) => {
      dispatch(activeLcd(lcdData));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const loginLogoutUserInRedux = useCallback(
    (data) => {
      dispatch(loginLogoutUserAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const fetchProfileData = () => {
    const userId = getUserData();
    let data = {
      uuid: userId,
      deal_uuid: getOnlyActiveLcdData().data["deal_uuid"],
      page: ADVERTISEMENT_PAGE["myprofile"],
    };
    axios
      .post(process.env.REACT_APP_API_URL + "/user/userProfile", data, {
        headers: getHeaderForAxios(),
      })
      .then(function (response) {
        // handle success
        if (response.data && response.data.success) {
          if (
            response.data.success.lcdData &&
            response.data.success.lcdData.length
          ) {
            let lcdData = response.data.success.lcdData;
            localStorage.setItem(
              "lcdData",
              JSON.stringify(EncryptData(lcdData))
            );
            addLcdData(lcdData);
            if (
              !getActiveLcdData().data.length &&
              lcdData[0].alphacode_identifier
            ) {
              localStorage.setItem(
                "alphaIdentifier",
                JSON.stringify(EncryptData(lcdData[0].alphacode_identifier))
              );
              activeLcdDetail({
                activeLcdIdentifier: lcdData[0].alphacode_identifier,
              });
            }
          }
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };
  useEffect(() => {
    const fetchData = async () => {
      if (selectedCountryData && !selectedCountryData.id) {
        let iso_code: string;
        await axios
          .get(process.env.REACT_APP_API_URL + "/common/find-trace")
          .then(function (response) {
            // handle success
            console.log("response >", response);
            if (response.data?.success) {
              if (
                response.data.success?.[
                  process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                ]
              ) {
                iso_code =
                  response.data.success[
                    process.env.REACT_APP_COUNTRY_PARAMETER ?? ""
                  ].trim();
              }

              // Optional: You can also access other trace data
              // const userIP = response.data.data.ip;
              // const dataCenter = response.data.data.colo;
              // const timestamp = response.data.data.timestamp;
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
        await axios
          .get(process.env.REACT_APP_API_URL + "/common/get-country-list")
          .then(function (response) {
            // handle success
            if (response.data && response.data.success) {
              let country_index = "";
              let country_id = "";
              let country_code = "";
              response.data.success.filter(function (data: any, index: any) {
                if (data.iso_code.toString() === iso_code) {
                  country_index = index;
                  country_id = data.id;
                  country_code = data.country_code;
                  return;
                }
              });
              setCountryData(response.data.success);
              setSelectedCountryData({
                index: country_index,
                id: country_id,
                code: country_code,
              });
            }
          })
          .catch(function (error) {
            // handle error
            if (error?.response?.data?.message)
              setLoginMessage({
                message: error.response.data.message,
                type: "error",
              });
            setLoading(false);
          });
      }
    };
    fetchData();
  }, [selectedCountryData]);

  const resetMessage = (setTime: number = 10000) => {
    setTimeout(() => {
      setLoginMessage({ message: "", type: "" });
    }, setTime);
  };
  useEffect(() => {
    const fetchData = () => {
      if (identifier && identifier?.userId && identifier?.otp) {
        axios
          .get(
            process.env.REACT_APP_API_URL +
              "/common/active-user/" +
              identifier.userId +
              "/" +
              identifier.otp
          )
          .then(function (response) {
            // handle success
            if (response.data && response.data?.message) {
              setLoginMessage({
                message: response.data?.message,
                type: "success",
              });
              localStorage.setItem("displayIntro", EncryptData("true"));
            }
          })
          .catch(function (error) {
            // handle error
            if (error?.response?.data?.message) {
              setLoginMessage({
                message: error.response.data.message,
                type: "error",
              });
            }
          });
      }
    };
    fetchData();
  }, [identifier]);
  const changeEmailInput = (e: any) => {
    let value = e.target.value;
    if (validation.submit) {
      let data = { ...validation };
      data["emailPhone"] = false;
      if (value) {
        if (!isNaN(parseInt(value))) {
          if (validatePhone(selectedCountryData.code + value)) {
            data["emailPhone"] = true;
          }
        } else if (validateEmail(value)) {
          data["emailPhone"] = true;
        }
      }
      setValidation(data);
    }
    if (value && value.length === 1) {
      if (!isNaN(parseInt(value))) {
        toggleEmailUse(false);
      } else {
        toggleEmailUse(true);
      }
    }
    setEmailPhone(value);
  };
  const changePasswordInput = (e: any) => {
    if (validation.submit) {
      let data = { ...validation };
      data["password"] = !!(e.target.value !== "");
      setValidation(data);
    }
    setPassword(e.target.value);
  };
  const submitSaveData = async (data: any) => {
    await axios
      .post(process.env.REACT_APP_API_URL + "/auth/login", data)
      .then(function (response) {
        if (
          response.data.success &&
          response.data.success.token &&
          response.data.success.user
        ) {
          refresh();
          localStorage.setItem(
            "loginData",
            JSON.stringify(EncryptData(response.data.success))
          );
          setLoginMessage({
            message: "Login Successfully you will redirect in 2 sec.",
            type: "success",
          });
          fetchProfileData();
          setTimeout(() => {
            loginLogoutUserInRedux({ isUserLogin: true });
            setRedirectToPage(true);
          }, 5000);
        }
      })
      .catch(function (error) {
        if (error.response && error.response.data) {
          let resendMessage = "";
          if (
            error.response.data?.error &&
            error.response.data?.error?.resend &&
            error.response.data?.error?.resendMessage
          ) {
            setResendLinkDisplay(true);
            resendMessage = error.response.data.error.resendMessage;
          }
          if (error.response.data.message) {
            setLoginMessage({
              message:
                error.response.data.message +
                (resendMessage ? resendMessage : ""),
              type: "error",
            });
          }
        }
        setLoading(false);
      });
  };
  const login = useGoogleLogin({
    scope:
      "https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/user.birthday.read",
    onSuccess: (codeResponse: any) => {
      console.log("codeResponse >", codeResponse);
      setUser(codeResponse);
    },
    onError: (error) => {
      console.log("Login Failed:", error);
    },
  });
  useEffect(() => {
    if (user?.access_token) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?alt=json`, {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        })
        .then((res: any) => {
          setProfile(res.data);
          axios
            .get(
              `https://people.googleapis.com/v1/people/${res.data.id}?personFields=phoneNumbers,genders,birthdays`,
              {
                headers: {
                  Authorization: `Bearer ${user.access_token}`,
                  Accept: "application/json",
                },
              }
            )
            .then((final) => {
              console.log("final >", final.data);
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  useEffect(() => {
    if (resendEmailConfirmation) {
      setResendEmailConfirmation(false);
      setResendLinkDisplay(false);
      if (isEmailUsing) {
        let data = {
          email: emailPhone,
        };
        axios
          .post(
            process.env.REACT_APP_API_URL + "/auth/resend-registration-link",
            data
          )
          .then(function (response) {
            // handle success
            if (response.data && response.data?.message) {
              setLoginMessage({
                message: response.data?.message,
                type: "success",
              });
            }
          })
          .catch(function (error) {
            // handle error
            if (error?.response?.data?.message) {
              setLoginMessage({
                message: error.response.data.message,
                type: "error",
              });
            }
          });
      }
    }
  }, [resendEmailConfirmation]);

  const onSubmit = (e: any) => {
    e.preventDefault();
    let data = { emailPhone: false, password: false, submit: true };
    let dataSubmit = {};
    if (emailPhone && isEmailUsing && validateEmail(emailPhone)) {
      dataSubmit = {
        email: emailPhone,
      };
      data["emailPhone"] = true;
    }
    if (!isEmailUsing && validatePhone(selectedCountryData.code + emailPhone)) {
      dataSubmit = {
        cs_id: selectedCountryData.id,
        phone: emailPhone,
      };
      data["emailPhone"] = true;
    }
    if (password) {
      dataSubmit = { ...dataSubmit, password: password };
      data["password"] = true;
    }
    if (data.emailPhone && data.password) {
      submitSaveData(dataSubmit);
    }
    setValidation(data);
  };
  useEffect(() => {
    if (loginMessage && loginMessage.message) {
      resetMessage(10000);
    }
  }, [loginMessage]);
  return (
    <div className="login-form-div">
      {redirectToPage ? <Redirect to="/user/profile" /> : null}
      {loginMessage.message ? (
        <div
          className={
            loginMessage.type === "success"
              ? "form-response success"
              : "form-response error"
          }
        >
          {loginMessage.message + " "}
          {resendLinkDisplay ? (
            <span
              className="bold theme-green pointer"
              onClick={() => setResendEmailConfirmation(true)}
            >
              Link
            </span>
          ) : (
            ""
          )}
        </div>
      ) : null}
      {/* {loading ? <Loading /> : null} */}
      <Form>
        <Form.Group
          className={`form-group ${emailPhone ? "focus" : ""}  ${
            validation.submit
              ? !validation.emailPhone
                ? "field-group-error"
                : "field-group-success"
              : ""
          }`}
          controlId="formBasicEmail"
        >
          <Form.Label htmlFor="nEmail">
            {LOGIN_PAGE[selectedLang]["emailPhone"]}
          </Form.Label>
          <Form.Control
            id="nEmail"
            type="text"
            autoComplete="new-email"
            className={`${
              validation.submit
                ? !validation.emailPhone
                  ? "focus-error"
                  : "focus-success"
                : ""
            }`}
            onChange={changeEmailInput}
          />
          <span className="input-append">
            <FaEnvelope />
          </span>
        </Form.Group>
        <Form.Group
          className={`form-group ${password ? "focus" : ""} ${
            validation.submit
              ? !validation.password
                ? "field-group-error"
                : "field-group-success"
              : ""
          }`}
          controlId="formBasicPassword"
        >
          <Form.Label htmlFor="nPassword">
            {LOGIN_PAGE[selectedLang]["password"]}
          </Form.Label>
          <Form.Control
            id="nPassword"
            type="password"
            autoComplete="new-password"
            className={`${
              validation.submit
                ? !validation.password
                  ? "focus-error"
                  : "focus-success"
                : ""
            }`}
            onChange={changePasswordInput}
          />
          <span className="input-append">
            <FaLock />
          </span>
        </Form.Group>
        <div className="form-group d-flex align-items-center justify-content-between">
          <Form.Group className="" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label={LOGIN_PAGE[selectedLang]["rememberMe"]}
            />
          </Form.Group>
          <Link to="/">{LOGIN_PAGE[selectedLang]["forgtPassword"]}</Link>
        </div>

        <Button
          variant="primary"
          type="submit"
          className="font-semibold"
          onClick={onSubmit}
        >
          {LOGIN_PAGE[selectedLang]["submit"]}
        </Button>
      </Form>
      <p className="sign-up-link">
        {LOGIN_PAGE[selectedLang]["accountMessage"]}{" "}
        <Link to="/register">{SIGN_UP_PAGE[selectedLang]["title"]}</Link>
      </p>
      {isGoogleOauthEnable ? (
        <div className="bottom-card d-md-none text-center">
          <p className="theme-green">Or</p>
          {/* <Link
          to="/"
          className="btn btn-fb d-flex align-items-center justify-content-center"
        >
          <span>Sign in with Google</span>
          <FaFacebookF />
        </Link> */}
          <button
            className="btn btn-fb d-flex align-items-center justify-content-center"
            onClick={() => login()}
          >
            <span>
              {LOGIN_PAGE[selectedLang]["signInWithGoogle"]} <FcGoogle />
            </span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
